import buttonSkin from "./buttons.skin";

const buttonDropdown = {
  "left-space": {
    "margin-left": "5px",
  },
  "bottom-space": {
    "margin-bottom": "5px",
  },
  "dropdown-menu-opened": {
    display: "block",
  },
  "dropdown-menu-closed": {
    display: "none",
  },
  "dropdown-menu-right": {
    right: "0",
  },
  "dropdown-menu": {
    background: "var(--gc-dark-background)",
    color: "var(--gc-dark-background-text-color)",
    "margin-top": "38px",
    position: "absolute",
    "z-index": "1000",
    "min-width": "10rem",
    padding: "0.5rem 0",
    margin: "0",
    "font-size": "1rem",

    "text-align": "left",
    "list-style": "none",

    "background-clip": "padding-box",
    border: "1px solid rgba(0, 0, 0, 0.175)",
    "border-radius": "0.375rem",
    "box-shadow": "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
  },
  "dropdown-item": {
    color: "var(--gc-dark-background-text-color)",
    display: "block",
    padding: "0.25rem 1rem",
    clear: "both",
    "font-weight": "400",
    "text-align": "inherit",
    "white-space": "nowrap",
    background: "none",
    border: "0",
    cursor: "pointer",
    "font-size": "1rem",
    "text-decoration": "none",
    "line-height": "1.5",
    "a&": {
      color: "var(--gc-dark-background-text-color)",
      "text-decoration": "none",
    },
    "a&:hover": {
      background: "var(--gc-light-background)",
      color: "var(--gc-light-background-text-color)",
      "text-decoration": "none",
    },
  },
  "dropdown-menu-container": {
    position: "relative",
    display: "inline-flex",
    "vertical-align": "middle",
  },
  "dropdown-menu-button": {
    position: "relative",
    flex: "1 1 auto",
    ...buttonSkin["simple-button"],
    "&::after": {
      display: "inline-block",
      "margin-left": "0.255em",
      "vertical-align": "0.255em",
      content: '""',
      "border-top": "0.3em solid",
      "border-right": "0.3em solid transparent",
      "border-bottom": "0",
      "border-left": "0.3em solid transparent",
      "border-top-color": "initial",
      "border-right-color": "transparent",
      "border-bottom-color": "initial",
      "border-left-color": "transparent",
    },
  },
};

export default buttonDropdown;
